import React, { useState, useRef } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { ExclamationCircleFilled, SearchOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography, Switch } from 'antd';
import { insert, update, dropDetail, getDetailsById, getById } from '../../../../apis/DefinicionPolizaApi';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { getAll } from '../../../../apis/PeriodosApi';
import { getList as getAllCuenta } from '../../../../apis/OdooCuentaApi';
import { getAll as getAllConcepto } from '../../../../apis/ConceptoApi';

import Details from './Details'
const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;

const normalizeSearchText = (value) =>
  (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const App = ({ title, id, open, finish }) => {
  const [form] = Form.useForm()
  const [ID, setID] = useState(id);
  const [showModal, setShowModal] = useState(false);
  const [dataDetails, setDataDetails] = useState([]);
  const [openNewDetails, setOpenNewDetails] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [initialValues, setInitialValues] = useState(null);
  const searchInput = useRef(null);
  const [tiposPeriodo, setTiposPeriodo] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [cuenta, setCuenta] = useState(null);

  const handleOk = async () => {
    const fields = form.getFieldsValue()
    if (ID > 0) {
      //Update
      const payload = {
        id: ID,
        activo: true,
        usar_analitica_centro_costos: false,
        ...fields
      }
      const response = await update(payload);
      if (response.ok) {
        message.success('Se actualizó correctamente la definición!');
        setShowModal(false);
        finish(true);
      }
    } else {
      //Create
      const payload = {
        id: ID,
        activo: true,
        usar_analitica_centro_costos: false,
        ...fields
      }
      const response = await insert(payload);
      if (response.ok) {
        setID(response.payload);

        message.success('Se guardo correctamente la definición!');
        setShowModal(false);
        finish(true);
      }
    }
  }

  const onClickNewDetail = () => {
    setOpenNewDetails(true);
    setSelectedDetail(null);
  }

  const onClose = () => {
    setShowModal(false);
    finish(false);
    setInitialValues(null);
    setID(id);
  }

  const finishDetail = async () => {
    setOpenNewDetails(false);
    await refreshDetails();
  }

  React.useEffect(() => {
    setShowModal(open);
  }, [open]);

  const effectRan = useRef(false);
  React.useEffect(() => {

    if (!effectRan.current) {
      (async () => {
        await getCatalogs();
        if (ID > 0) {
          refreshData();
        } else {
          setInitialValues({
            descripcion: '',
            clave: '',
            cuenta_balance: '',
            interface_directa_odoo: false,
            agrupar_cuenta: false,
            usar_analitica: false,
            usar_analitica_centro_costos: false,
            usar_analitica_area: false,
            usar_analitica_departamento: false,
            poliza_liquidacion: false,
            metodo_analitica: 'prorratear',
          });
        }
      })();
    }
    return () => effectRan.current = true;
  }, [ID]);

  const refreshData = async () => {
    await refreshPeriodo();
    await refreshDetails();
  }

  const refreshPeriodo = async () => {
    const response = await getById(ID);
    if (response.ok) {
      let periodo = response.payload;
      setInitialValues(periodo);
    }
  }

  const refreshDetails = async () => {
    const response = await getDetailsById(ID);
    if (response.ok) {
      let list = response.payload;

      // Ordenar por número de concepto (clave_concepto) de menor a mayor
      const sortedList = list.sort((a, b) => {
        const claveA = parseInt(a.clave_concepto) || 0;
        const claveB = parseInt(b.clave_concepto) || 0;
        return claveA - claveB;
      });

      setDataDetails(sortedList);
    }
  }

  const getCatalogs = async () => {
    const responsePeriodos = await getAll();
    if (responsePeriodos.ok) {
      let items = responsePeriodos.payload;
      setTiposPeriodo(items);
    }

    const responseCuentas = await getAllCuenta();
    if (responseCuentas.ok) {
      let cuentasItems = responseCuentas.payload.map(item => ({
        value: item.id,
        text: item.display_name || `${item.code} - ${item.name}`,
        id: item.id,
        originalData: item
      }));
      setCuentas(cuentasItems);
      console.log('Cuentas cargadas:', cuentasItems);
    }

    // Obtener conceptos
    const responseConceptos = await getAllConcepto();
    if (responseConceptos.ok) {
      let items = responseConceptos.payload.map(item => ({
        value: item.id,
        text: item.displayTitle || `(${item.clave}) ${item.descripcion}`,
        clave: item.clave,
        originalData: item
      }));
      setConceptos(items);
      console.log('Conceptos cargados:', items);
    }
  }

  const deleteConfirm = async (item) => {
    confirm({
      title: '¿Confirmas en eliminar el detalle?',
      icon: <ExclamationCircleFilled />,
      content: 'No podrás recuperar su información',
      onOk: () => { deleteOk(item.id) },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deleteOk = async (id) => {
    const response = await dropDetail(id);
    if (response.ok) {
      message.success('¡El detalle ha sido eliminadó!');
      await refreshDetails();
    }
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const changeCuenta = async (value) => {
    var _cuenta = cuentas.find(x => x.value == value);

    if (_cuenta) {
      setCuenta(_cuenta);
      console.log("Cuenta cambiada:", _cuenta);
    } else {
      console.warn("No se encontró la cuenta con ID:", value);
    }
  }

  // Función para obtener la descripción concatenada del concepto
  const getConceptoDisplay = (claveConcepto) => {
    const concepto = conceptos.find(c => c.clave === claveConcepto);
    if (concepto) {
      return concepto.text; // Ya viene formateado como "(clave) descripcion"
    }
    return claveConcepto; // Si no se encuentra, mostrar solo la clave
  }

  const columns = [
    {
      title: 'Concepto',
      dataIndex: 'clave_concepto',
      key: 'clave_concepto',
      render: (claveConcepto) => {
        return getConceptoDisplay(claveConcepto);
      }
    },
    {
      title: 'Analitica',
      dataIndex: ['analitica', 'name'],
      key: 'analitica',
    },
    {
      title: 'Cuenta',
      dataIndex: ['cuenta', 'display_name'],
      key: 'cuenta',
    },
    {
      title: 'Generar',
      dataIndex: 'generar',
      key: 'generar',
      render: (item, object) => {
        if (item)
          return <Tag color="green">Si</Tag>;
        else
          return <Tag color="red">No</Tag>;
      }
    },
    {
      title: 'Signo',
      dataIndex: 'signo',
      key: 'signo',
      render: (item, object) => {
        if (item)
          return <Tag color="green">+</Tag>;
        else
          return <Tag color="red">-</Tag>;
      }
    },
    {
      title: 'Tipo Cuenta',
      dataIndex: 'tipo_cuenta',
      key: 'tipo_cuenta',
      render: (tipoCuenta, object) => {
        if (tipoCuenta === 0)
          return <Tag color="blue">Cargo</Tag>;
        else if (tipoCuenta === 1)
          return <Tag color="orange">Abono</Tag>;
        else
          return <Tag color="gray">N/A</Tag>;
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (item, object) => {
        return <Space>
          <Button type='primary' size='small' onClick={() => {
            setOpenNewDetails(true);
            setSelectedDetail(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={() => {
            deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
      }
    }
  ];

  return (
    <Drawer
      title={<>
        {ID > 0 ? '(' + ID + ') ' : ''}
        {title}
      </>}
      width={'100%'}
      placement={"right"}
      onClose={onClose}
      open={open}
      closable={true}
      height={'100%'}
      styles={{
        body: {
          paddingBottom: 80,
        },
      }}
      extra={[
        <Space>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleOk} type="primary">
            Guardar
          </Button>
        </Space>
      ]}
    >
      <>
        <div>
          <div style={{ float: 'left' }}>
            <span title=""></span>
          </div>
          <span class="" style={{ float: 'right' }}>
          </span>
        </div>
        {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>]} />*/}
        {
          initialValues &&
          <Form layout="vertical" form={form} hideRequiredMark initialValues={initialValues} onFinish={handleOk}>
            <Row gutter={16}>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="clave"
                  label="Clave"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor agrega la clave',
                    },
                  ]}>
                  <Input placeholder="Por favor agrega la clave" style={{ width: '80%', }} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="descripcion"
                  label="Descripcion"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor agrega una descripion',
                    },
                  ]}>
                  <Input placeholder="Por favor agrega una descripion" style={{ width: '80%', }} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="diario"
                  label="Diario"
                >
                  <Input placeholder="Por favor agrega una descripion" style={{ width: '80%', }} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="interface_directa_odoo"
                  label="Interfase Directa a Odoo"
                >
                  <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                </Form.Item>
              </Col>

              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="cuenta_balance_id"
                  label="Cuenta de Balance"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor escribe la cuenta',
                    },
                  ]}
                >
                  <Select
                    placeholder="Por favor selecciona una cuenta"
                    onChange={changeCuenta}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      const normalizedInput = normalizeSearchText(input);
                      const optionText = normalizeSearchText(option?.children);
                      return optionText.includes(normalizedInput);
                    }}
                    filterSort={(optionA, optionB, { searchValue }) => {
                      const normalizedSearch = normalizeSearchText(searchValue);
                      const textA = normalizeSearchText(optionA?.children);
                      const textB = normalizeSearchText(optionB?.children);

                      const startsWithA = textA.startsWith(normalizedSearch);
                      const startsWithB = textB.startsWith(normalizedSearch);

                      if (startsWithA !== startsWithB) {
                        return startsWithA ? -1 : 1;
                      }

                      const includesA = textA.includes(normalizedSearch);
                      const includesB = textB.includes(normalizedSearch);

                      if (includesA !== includesB) {
                        return includesA ? -1 : 1;
                      }

                      return textA.localeCompare(textB);
                    }}
                    style={{ width: '80%', }}
                  >
                    {
                      cuentas.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="agrupar_cuenta"
                  label="Agrupar por cuenta"
                >
                  <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="usar_analitica"
                  label="Usar Analitica"
                >
                  <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => prevValues.usar_analitica !== currentValues.usar_analitica}
                >
                  {({ getFieldValue }) => {
                    const usarAnalitica = getFieldValue('usar_analitica');
                    return (
                      <Form.Item
                        name="metodo_analitica"
                        label="Método de Distribución Analítica"
                        tooltip={{
                          title: 'Prorratear: Distribuye el 100% según horas trabajadas. Completar CC: Completa horas faltantes con el centro de costo por defecto del empleado.',
                          icon: <InfoCircleOutlined />
                        }}
                        rules={[
                          {
                            required: usarAnalitica,
                            message: 'Por favor selecciona un método de distribución',
                          },
                        ]}
                      >
                        <Select
                          placeholder="Selecciona el método de distribución"
                          style={{ width: '80%' }}
                          disabled={!usarAnalitica}
                        >
                          <Option value="prorratear">
                            <Space direction="vertical" size={0}>
                              <span><strong>Prorratear</strong></span>
                            </Space>
                          </Option>
                          <Option value="completar_cc">
                            <Space direction="vertical" size={0}>
                              <span><strong>Completar con Centro de Costo</strong></span>
                            </Space>
                          </Option>
                        </Select>
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="usar_analitica_area"
                  label="Usar Analitica de Area"
                >
                  <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="usar_analitica_departamento"
                  label="Usar Analitica de Departamento"
                  initialValue={false}
                >
                  <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} disabled={true} />
                </Form.Item>
              </Col>
              <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                <Form.Item
                  name="poliza_liquidacion"
                  label="Poliza de liquidación"
                >
                  <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        }

        <Divider></Divider>
        <div style={{ height: 60 }}>
          <div style={{ float: 'left' }}>
            <Title level={2}>Detalles</Title>
          </div>
          <span class="" style={{ float: 'right' }}>
            <Space>
              <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{ marginBottom: 10 }}>Agregar nuevo detalle</Button>
              {/* <Button onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button> */}
            </Space>
          </span>
        </div>
        {
          openNewDetails &&
          <div style={{ marginBottom: 10 }}>
            {
              !selectedDetail &&
              <Details title="Agregar detalle" definicionPolizaId={ID} finish={finishDetail} open={openNewDetails} />
            }
            {
              selectedDetail &&
              <Details title="Editar detalle" definicionPolizaId={ID} id={selectedDetail.id} finish={finishDetail} open={openNewDetails} />
            }
          </div>
        }
        {/* <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button> */}
        {
          dataDetails.length === 0 ? <Empty /> :
            <Table dataSource={dataDetails} columns={columns} />
        }
      </>
    </Drawer>
  );
};
export default App;